<template>
<v-card class="ma-1 pa-1" flat>
    <v-card dark class="pa-1" color="primary" >
      <v-card light color="primary--text" class="title  pa-2 pl-3" title>
      Revision history
      </v-card>
      </v-card>
      <v-expansion-panels light class="pa-1" accordion>
        <v-expansion-panel v-for="version in versions" :key="version.id" class="primary--text">
          <v-expansion-panel-header disable-icon-rotate class="ma-0 pa-0 pl-2" >
            {{'Revision '+version.id}}
            <template v-slot:actions>              
              <v-btn  text max-height="20" class="overline">Update 
                <v-icon right color="primary"  @click="doSomething(version.path)" class="px-1 ml-1">$vuetify.icons.upgrade</v-icon>
              </v-btn>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="ma-0 pa-0">
                <v-input v-if="version.newFeatures" class="ma-0 pa-0 pl-1 caption" :error-count="version.newFeatures.length" :error-messages="version.newFeatures" error disabled>New Features</v-input>
                <v-input v-if="version.bugsFixed" class="ma-0 pa-0 pl-1 caption" :error-count="version.bugsFixed.length" :error-messages="version.bugsFixed" error disabled>Fixed Bugs</v-input>
                <v-input v-if="version.knownProblems" class="ma-0 pa-0 pl-1 caption" :error-count="version.knownProblems.length" :error-messages="version.knownProblems" error disabled>Known Problems</v-input>
          </v-expansion-panel-content>
          </v-expansion-panel>
      </v-expansion-panels>
    
</v-card>
</template>

<script>
import store from '../main'
import db from '../javascript/bluetooth'

export default {
  name: 'fwUpgrade',
  components: {
    
  },
  data() {
    return {
      versions:[]
    }
  },
  methods:{
    doSomething(path){
      this.$store.dispatch("UpgradeFirmware",{path:path})
    }
  },
  beforeUpdate: function () {
console.log('versions ' +this.versions )
  
  },
  created() {
    //const query = db.collection('devices').doc('MHD001').collection('Versions').orderBy('createDate',"desc");
    db.collection('devices').doc(this.$store.getters.getDeviceName).collection("Versions").orderBy('createDate',"asc").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.versions.unshift({
            ...change.doc.data(),
            id: change.doc.id
          })
        }  
      })
    })
  }
}

</script>